function initMockingbirdBaseball(root) {
  if (!root || root.dataset.mbmReady === 'true') return;
  root.dataset.mbmReady = 'true';

  const cards = [...root.querySelectorAll('.mbm-product')];
  const filterButtons = [...root.querySelectorAll('[data-mbm-filter]')];
  const designButtons = [...root.querySelectorAll('[data-mbm-design]')];
  const designsSection = root.querySelector('#mbm-baseball-designs');
  const shopRoot = window.Shopify?.routes?.root || '/';
  const collectionName = root.dataset.mbmCollection || 'Custom Collection';
  const customizationVariantCache = new Map();
  let activeCard = null;
  let activeDesignSlot = 'primary';

  const formatMoney = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(cents / 100);

  async function getCustomizationVariant(handle) {
    if (!handle) throw new Error('A customization product handle is missing in the theme settings.');
    if (customizationVariantCache.has(handle)) return customizationVariantCache.get(handle);
    const response = await fetch(`${shopRoot}products/${encodeURIComponent(handle)}.js`);
    if (!response.ok) throw new Error(`The customization product “${handle}” was not found.`);
    const product = await response.json();
    const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
    if (!variant) throw new Error(`The customization product “${handle}” has no purchasable variant.`);
    customizationVariantCache.set(handle, variant.id);
    return variant.id;
  }

  function updateCustomizerSummary(card) {
    const summary = card.querySelector('.mbm-customizer summary');
    const primaryDesign = card.querySelector('[data-mbm-card-design]')?.value || '1';
    const addon = card.querySelector('[data-mbm-addon]');
    const additionalDesign = card.querySelector('[data-mbm-additional-design]')?.value;
    if (!summary) return;
    summary.textContent = addon?.checked && additionalDesign
      ? `Customize · Design ${primaryDesign} + Design ${additionalDesign}`
      : `Customize this item · Design ${primaryDesign}`;
  }

  function filterProducts(category) {
    filterButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.mbmFilter === category));
    cards.forEach((card) => {
      const categories = (card.dataset.mbmCategory || '').split(/\s+/);
      card.classList.toggle('mbm-hide', category !== 'all' && !categories.includes(category));
    });
  }

  filterButtons.forEach((button) => button.addEventListener('click', () => filterProducts(button.dataset.mbmFilter)));
  root.querySelectorAll('[data-mbm-jump]').forEach((link) => link.addEventListener('click', () => filterProducts(link.dataset.mbmJump)));

  cards.forEach((card) => {
    card.querySelectorAll('[data-mbm-choose-design]').forEach((chooseDesign) => {
      chooseDesign.addEventListener('click', () => {
        activeCard = card;
        activeDesignSlot = chooseDesign.dataset.mbmDesignSlot || 'primary';
        const selectedDesign = activeDesignSlot === 'additional'
          ? card.querySelector('[data-mbm-additional-design]')?.value
          : card.querySelector('[data-mbm-card-design]')?.value;
        designButtons.forEach((choice) => choice.classList.toggle('is-selected', Boolean(selectedDesign) && choice.dataset.mbmDesign === selectedDesign));
        designsSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  });

  designButtons.forEach((button) => {
    button.addEventListener('click', () => {
      designButtons.forEach((choice) => choice.classList.toggle('is-selected', choice === button));
      if (!activeCard) return;

      const designNumber = button.dataset.mbmDesign;
      const designField = activeCard.querySelector(activeDesignSlot === 'additional' ? '[data-mbm-additional-design]' : '[data-mbm-card-design]');
      const designLabel = activeCard.querySelector(activeDesignSlot === 'additional' ? '[data-mbm-additional-design-label]' : '[data-mbm-card-design-label]');
      if (designField) designField.value = designNumber;
      if (designLabel) designLabel.textContent = `Design ${designNumber}`;
      updateCustomizerSummary(activeCard);
      activeCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  cards.forEach((card) => {
    const variants = JSON.parse(card.querySelector('[data-mbm-variants]')?.textContent || '[]');
    const optionSelects = [...card.querySelectorAll('[data-mbm-product-option]')];
    const addon = card.querySelector('[data-mbm-addon]');
    const addonOptions = card.querySelector('[data-mbm-addon-options]');
    const name = card.querySelector('[data-mbm-name]');
    const number = card.querySelector('[data-mbm-number]');
    const basePriceDisplay = card.querySelector('[data-mbm-base-price-display]');
    const total = card.querySelector('[data-mbm-total]');
    const addButton = card.querySelector('[data-mbm-add-to-cart]');
    const cartStatus = card.querySelector('[data-mbm-cart-status]');

    const selectedVariant = () => variants.find((variant) => optionSelects.every((select) => {
      const optionIndex = Number(select.dataset.mbmProductOption) - 1;
      return variant.options?.[optionIndex] === select.value;
    })) || variants[0];

    const updateTotal = () => {
      const variant = selectedVariant();
      const basePrice = Number(variant?.price ?? card.dataset.mbmBasePrice ?? 0);
      let additions = addon && addon.checked ? 500 : 0;
      const hasName = Boolean(name && name.value.trim());
      const hasNumber = Boolean(number && number.value.trim());
      additions += hasName && hasNumber ? 800 : (hasName || hasNumber ? 500 : 0);
      if (basePriceDisplay) basePriceDisplay.textContent = formatMoney(basePrice);
      if (total) total.textContent = formatMoney(basePrice + additions);
    };

    if (addon) {
      addon.addEventListener('change', () => {
        if (addonOptions) addonOptions.hidden = !addon.checked;
        updateTotal();
        updateCustomizerSummary(card);
      });
    }
    [name, number].filter(Boolean).forEach((field) => field.addEventListener('input', updateTotal));
    optionSelects.forEach((select) => select.addEventListener('change', updateTotal));

    addButton?.addEventListener('click', async () => {
      const variant = selectedVariant();
      const primaryDesign = card.querySelector('[data-mbm-card-design]')?.value;
      const primaryPlacement = card.querySelector('[data-mbm-primary-placement]')?.value;
      const additionalDesign = card.querySelector('[data-mbm-additional-design]')?.value;
      const additionalPlacement = card.querySelector('[data-mbm-additional-placement]')?.value;
      const playerName = name?.value.trim() || '';
      const playerNumber = number?.value.trim() || '';
      const productTitle = card.querySelector('.mbm-product__info h3')?.textContent.trim() || 'Configured item';

      const showError = (message) => {
        if (cartStatus) cartStatus.textContent = message;
      };

      if (!variant?.id || variant.available === false) {
        showError('That size and color combination is unavailable. Please choose another option.');
        return;
      }
      if (addon?.checked && (!additionalDesign || !additionalPlacement)) {
        showError('Please choose the additional logo design and its placement.');
        return;
      }

      addButton.disabled = true;
      addButton.textContent = 'Adding…';
      showError('');

      try {
        const mainProperties = {
          Collection: collectionName,
          'Primary Logo': `Design ${primaryDesign || '1'}`,
          'Primary Logo Placement': primaryPlacement || 'Front center'
        };
        if (addon?.checked) {
          mainProperties['Additional Logo'] = `Design ${additionalDesign}`;
          mainProperties['Additional Logo Placement'] = additionalPlacement;
        }
        if (playerName) mainProperties['Player Name'] = playerName;
        if (playerNumber) mainProperties['Player Number'] = playerNumber;

        const items = [{ id: variant.id, quantity: 1, properties: mainProperties }];
        if (addon?.checked) {
          items.push({
            id: await getCustomizationVariant(root.dataset.mbmFiveHandle),
            quantity: 1,
            properties: { For: productTitle, Collection: collectionName, Customization: 'Additional logo', Design: `Design ${additionalDesign}`, Placement: additionalPlacement }
          });
        }
        if (playerName && playerNumber) {
          items.push({
            id: await getCustomizationVariant(root.dataset.mbmEightHandle),
            quantity: 1,
            properties: { For: productTitle, Collection: collectionName, Customization: 'Name + number', Name: playerName, Number: playerNumber }
          });
        } else if (playerName || playerNumber) {
          items.push({
            id: await getCustomizationVariant(root.dataset.mbmFiveHandle),
            quantity: 1,
            properties: { For: productTitle, Collection: collectionName, Customization: playerName ? 'Player name' : 'Player number', Value: playerName || playerNumber }
          });
        }

        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'This item could not be added to the cart.');
        }
        window.location.assign(`${shopRoot}cart`);
      } catch (error) {
        showError(error.message || 'This item could not be added to the cart. Please try again.');
        addButton.disabled = false;
        addButton.textContent = 'Add configured item to cart';
      }
    });

    updateTotal();
  });

  const modal = root.querySelector('[data-mbm-gallery]');
  const mainImage = modal.querySelector('[data-mbm-gallery-main]');
  const title = modal.querySelector('[data-mbm-gallery-title]');
  const thumbs = modal.querySelector('[data-mbm-gallery-thumbs]');
  const customizeButton = modal.querySelector('[data-mbm-gallery-customize]');
  let trigger = null;

  function selectImage(source, alt, button) {
    mainImage.src = source;
    mainImage.alt = alt;
    thumbs.querySelectorAll('.mbm-gallery__thumb').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
  }

  function closeGallery() {
    modal.hidden = true;
    document.body.style.overflow = '';
    mainImage.src = '';
    if (trigger) trigger.focus();
  }

  root.querySelectorAll('[data-mbm-open-gallery]').forEach((button) => {
    button.addEventListener('click', () => {
      trigger = button;
      const data = button.closest('.mbm-product').querySelector('[data-mbm-gallery-data]');
      const images = [...data.content.querySelectorAll('img')];
      title.textContent = data.dataset.title;
      thumbs.innerHTML = '';
      images.forEach((image, index) => {
        const thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = `mbm-gallery__thumb${index === 0 ? ' is-active' : ''}`;
        thumb.setAttribute('aria-label', `View photo ${index + 1} of ${images.length}`);
        const thumbImage = image.cloneNode();
        thumb.appendChild(thumbImage);
        thumb.addEventListener('click', () => selectImage(image.src, image.alt, thumb));
        thumbs.appendChild(thumb);
      });
      if (images[0]) selectImage(images[0].src, images[0].alt, thumbs.firstElementChild);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.querySelector('.mbm-gallery__close').focus();
    });
  });

  modal.querySelector('.mbm-gallery__close').addEventListener('click', closeGallery);
  customizeButton?.addEventListener('click', () => {
    const card = trigger?.closest('.mbm-product');
    closeGallery();
    if (card) {
      card.querySelector('.mbm-customizer')?.setAttribute('open', '');
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  modal.addEventListener('click', (event) => { if (event.target === modal) closeGallery(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !modal.hidden) closeGallery(); });
}

document.querySelectorAll('[data-mbm-baseball]').forEach(initMockingbirdBaseball);
document.addEventListener('shopify:section:load', (event) => initMockingbirdBaseball(event.target.querySelector('[data-mbm-baseball]')));
